import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { CYCLE_RUNS_CRUD_ACTION_CREATORS } from '../actions/cycle_runs_actions';
import { getBackendUri } from '../utils/EnvConfigUtils';
import FetchUtils, { parseJSON } from './fetch_utils';
import { message } from 'antd';
import CycleRunPipeLineFilters from '../components/asset_cycle_runs_detail_details_page/CycleRunPipeLineFilters';
import { logoutSuccess } from '../actions/session_actions';

const fetchUtils = new FetchUtils();
const BASE_URL = getBackendUri();

export const cycleRunsRestCrudThunksForBuyer = new RestCrudThunks(
	'asset_cycle_count_runs',
	'asset_cycle_run',
	'asset_cycle_run',
	'asset_cycle_count_runs',
	CYCLE_RUNS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'asset/'
);

export const cycleRunsRestCrudThunksForSupplier = new RestCrudThunks(
	'asset_cycle_count_runs',
	'asset_cycle_run',
	'asset_cycle_run',
	'asset_cycle_count_runs',
	CYCLE_RUNS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'asset/'
);

export const refreshCycleRunCounts = (roleType) => (filters) => (dispatch) => {
	const apiUrl = `/api/v1/${roleType}/asset/asset_cycle_count_runs/count_by_status`;

	const data = {
		...(filters || {}),
		statuses: CycleRunPipeLineFilters.map((_) => _.name).join(','),
		status: undefined,
	};
	fetchUtils
		.get(
			BASE_URL + apiUrl,
			Object.assign(
				{
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				},
				data
			)
		)
		.then(parseJSON)
		.then(({ json, status, ok }) => {
			const d = json;
			if (d.status === 'error') {
				message.error(d.message);
			} else {
				if (d.data && d.data.length > 0) {
					d.data.map((category) =>
						dispatch(
							CYCLE_RUNS_CRUD_ACTION_CREATORS.countBySuccess(category.count, category.categoryName)
						)
					);
				}
			}
		})
		.catch((d) => {
			message.error(d.message);
		});
};

export const approveAllAudits = (roleType) => (entity) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(CYCLE_RUNS_CRUD_ACTION_CREATORS.updateStart(entity));

			const baseUrl = getBackendUri();
			const apiUrl = `/api/v1/${roleType}/asset/asset_cycle_count_runs/approve_all/${entity.id}`;

			fetchUtils
				.patch(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(CYCLE_RUNS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(CYCLE_RUNS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(CYCLE_RUNS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const approveAllAuditsByMatchStatus = (roleType) => (entity, status) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(CYCLE_RUNS_CRUD_ACTION_CREATORS.updateStart(entity));

			const baseUrl = getBackendUri();
			const apiUrl = `/api/v1/${roleType}/asset/asset_cycle_count_runs/approve_all/${entity.id}/by_match_status/${status}`;

			fetchUtils
				.patch(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(CYCLE_RUNS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(CYCLE_RUNS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(CYCLE_RUNS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const applyChangesToACCRun = (roleType) => (accRunId) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/asset/asset_cycle_count_runs/${accRunId}/apply_changes`;

	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(CYCLE_RUNS_CRUD_ACTION_CREATORS.updateStart({}));

			fetchUtils
				.post(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					})
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(CYCLE_RUNS_CRUD_ACTION_CREATORS.updateError(d.message, {}));
						reject(d.message);
					} else {
						dispatch(CYCLE_RUNS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(CYCLE_RUNS_CRUD_ACTION_CREATORS.updateError(d.message, {}));
					reject(d.message);
				});
		});
	};
};

export const getACCRunApplyChangesStatus = (roleType) => () => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/asset/asset_cycle_count_runs/apply_changes/status`;

	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					})
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
						message.error(d.data);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};
